import { AuthId } from "@common/constans";
import { IFeedback, IRequest, IResponse } from "@common/models";
import { IComment } from "@common/models/Comment";
import { IFeedbackDetailsRequest } from "@common/models/FeedbackDetailsRequest";
import { IParticipate } from "@common/models/Participate";
import { IParticipateRequest } from "@common/models/ParticipateRequest";
import { ISharingRequest } from "@common/models/SharingRequest";
import { ISharingResponse } from "@common/models/SharingResponse";
import { ISurveyConfirm } from "@common/models/SurveyConfirm";
import Api, { IOptions } from "@service/Api";
import { Action } from ".";

export function sendFeedback<T = IFeedback, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Feedback", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function feedbackDetails<T = IFeedbackDetailsRequest, U = IFeedback>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Feedback/Details", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function feedbackCreateComment<T = IComment, U = IComment>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Feedback/Comment/Create", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function memberFeedbacks<T = IRequest<string>, U = IFeedback[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Member/Feedbacks", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function submitSurvey<T = ISurveyConfirm, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Survey", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function makeParticipate<T = IParticipateRequest, U = IParticipate>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate", {
                ...options,
                raiseError: options?.raiseError ?? true,
                captchaRequierd: options?.captchaRequierd ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateCreateFeedback<T = IFeedback, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/Feedback/Create", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateSurvey<T = ISurveyConfirm, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/Survey", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateFeedbacks<T = IParticipate, U = IFeedback[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/Feedbacks", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateModifyFeedback<T = IFeedback, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/Feedback/Modify", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateDeleteFeedback<T = IFeedback, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/Feedback/Delete", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateShortenLink<T = ISharingRequest, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/ShortenLink", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function participateShare<T = ISharingRequest, U = ISharingResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("CustomerService/Participate/Share", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.FlightSurvay,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}
